export default __webpack_public_path__ + "static/activity_icon-293e8a570052f06d2695006bc3455398.png";